module.exports = __webpack_public_path__ + "static/media/icon-sku.fb3e2cb9.svg";